export default __webpack_public_path__ + "static/banner-405e8f6487429e7781ba35f2976c4969.png";